import React from "react";

const getPasswordStrength = (password) => {
  let strength = 0;
  if (password.length >= 8) strength++;
  if (/[A-Z]/.test(password)) strength++;
  if (/[a-z]/.test(password)) strength++;
  if (/\d/.test(password)) strength++;
  if (/[@$!%*?&#^+=]/.test(password)) strength++;
  return strength;
};

const PasswordStrengthBar = ({ password }) => {
  const strength = getPasswordStrength(password);
  const colors = ["#ccc", "red", "orange", "gold", "lightgreen", "green"];
  const labels = ["", "Very Weak", "Weak ", "Fair ", "Good ", "Strong "];

  return (
    <div style={{ marginTop: "6px" }}>
      <div
        style={{
          height: "10px",
          background: "#eee",
          borderRadius: "4px",
        }}
      >

        <div
          style={{
            width: `${(strength / 5) * 100}%`,
            height: "100%",
            backgroundColor: colors[strength],
            borderRadius: "4px",
            transition: "width 0.3s ease",
          }}
        />
      </div>
      {password && (
        <small style={{ color: colors[strength] }}>{labels[strength]}</small>
      )}
    </div>
  );
};

export default PasswordStrengthBar;
